module.exports = __webpack_public_path__ + "static/media/empress-of-forever.6564f4a5.jpg";